import { handleFreeReturn } from '@lambda/commons/helpers';
import { NavigationT } from './types';
import settings from '@/settings';
import deliveryIcon from '@/public/icons/collection/category/stars.svg';
import returnIcon from '@/public/icons/collection/category/return.svg';
import warrantyIcon from '@/public/icons/collection/category/warranty.svg';
import { CheckoutStep } from './enums';
import { generateCartWarrantyText } from '../cart';
import i18n from '@/settings/i18n';

const t = i18n.init('cart');

const freeReturnDays = handleFreeReturn(
  settings.store,
  settings.free_return_days,
);

export const generateUsps = async ({
  categoryPks,
  conditions,
}: {
  categoryPks: string[];
  conditions: string[];
}) => {
  const warrantyLabel = await generateCartWarrantyText({
    categoryPks,
    conditions,
    freeReturnDays,
  });

  return [
    {
      label: t`${{ freeReturnDays }}-Day Return Policy`,
      icon: returnIcon,
    },
    { label: t`Free Shipping & Returns`, icon: deliveryIcon },
    ...(warrantyLabel
      ? [
          {
            label: warrantyLabel,
            icon: warrantyIcon,
          },
        ]
      : []),
  ];
};

export const NAVIGATION: NavigationT[] = [
  { label: 'Cart', value: CheckoutStep.Cart, handle: 'cart' },
  { label: 'Shipping', value: CheckoutStep.Shipping },
  { label: 'Payment', value: CheckoutStep.Payment },
];
